import { render, staticRenderFns } from "./single-garbage-center.vue?vue&type=template&id=c0948bc2&scoped=true&"
import script from "./single-garbage-center.vue?vue&type=script&lang=js&"
export * from "./single-garbage-center.vue?vue&type=script&lang=js&"
import style0 from "./single-garbage-center.vue?vue&type=style&index=0&id=c0948bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0948bc2",
  null
  
)

export default component.exports